import { useAnalyticsSkuViewedContext } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed/Context';
import {
  CTASearchParams,
  type SearchParamValue,
} from '@cc-shopping/platform-analytics/lib/ctaSearchParams';
import { FinishType } from '@cc-shopping/platform-analytics/types';
import type { SxProps } from '@mui/material';
import { type CtaAnalyticsProps, CtaLink } from '../CTA/CtaLink';

interface RatesAndFeesLinkProps {
  href: string;
  analytics: CtaAnalyticsProps;
  versionId: number;
  additionalParams?: Record<string, SearchParamValue>;
  children?: React.ReactNode;
  showBlankTargetIcon?: boolean;
  onClickAnalyticsCallback?: () => void;
  containerSxProps?: SxProps;
  name: string;
}

export const RatesAndFeesLink = ({
  href,
  analytics,
  children,
  additionalParams,
  showBlankTargetIcon,
  onClickAnalyticsCallback,
  containerSxProps,
  name,
}: RatesAndFeesLinkProps) => {
  const { shoppingFinishedId } = useAnalyticsSkuViewedContext();

  return (
    <CtaLink
      analytics={analytics}
      type="RATES_AND_FEES_TEXT"
      href={href}
      finishType={FinishType.ExternalApplication}
      onClickAnalyticsCallback={onClickAnalyticsCallback}
      rel="nofollow"
      target="_blank"
      underline="hover"
      sx={{
        textAlign: 'center',
        fontSize: { xs: '.7125rem', md: '0.75rem' },
        ...containerSxProps,
      }}
      parameterActions={[
        CTASearchParams.MONETIZING,
        CTASearchParams.SHOPPING_FINISH,
        {
          replacements: {
            cta_type: 'RATES_AND_FEES_TEXT',
            monetizable: analytics.monetizable ?? '',
            ...additionalParams,
          },
        },
      ]}
      aria-label={`View rates and fees for ${name}`}
      shoppingFinishedId={shoppingFinishedId}
    >
      {children ? children : 'Rates & Fees'}
      {showBlankTargetIcon && (
        <span
          aria-hidden="true"
          className="mask-icon mask-icon-open-in-new"
          style={{
            width: '1rem',
            height: '1rem',
            marginLeft: '8px',
            verticalAlign: 'sub',
          }}
        />
      )}
    </CtaLink>
  );
};
